export const L10N = {
  ACTION_VIEW_MORE: { id: 'common.action.view_more' },
  ACTION_VIEW_HOTEL: { id: 'common.action.view_hotel' },

  LABEL_DISCOUNT: { id: 'core.label.discount' },
  LABEL_DISTANCE: { id: 'core.label.distance' },
  LABEL_EXCLUDES_TAXES_FEES: { id: 'core.label.excludes_taxes_fees' },
  LABEL_FOR_NIGHTS: { id: 'common.label.for_nights' },
  LABEL_INCLUDES_TAXES_FEES: { id: 'core.label.includes_taxes_fees' },
  LABEL_ONLY_MEMBERS_DISCOUNT: { id: 'core.label.only_members_discount' },
  LABEL_PER_NIGHT: { id: 'core.label.per_night' },
};
